var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['pe_notification', { 'pe_active': _vm.isOpen }],on:{"click":_vm.close}},[_c('icon-cross'),_vm._v(" "+_vm._s(_vm.message)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }